<span [@fadeScrollButton]="scrollPossible" class="bottom-right text-bg-primary" (click)="mainService.scrollToTop()"><i class="fas fa-arrow-up"></i></span>